import listActions from 'src/modules/centroCosto/list/centroCostoListActions';
import CentroCostoService from 'src/modules/centroCosto/centroCostoService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'CENTROCOSTO_DESTROY';

const centroCostoDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: centroCostoDestroyActions.DESTROY_STARTED,
      });

      await CentroCostoService.destroyAll([id]);

      dispatch({
        type: centroCostoDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.centroCosto.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/centro-costo');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: centroCostoDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: centroCostoDestroyActions.DESTROY_ALL_STARTED,
      });

      await CentroCostoService.destroyAll(ids);

      dispatch({
        type: centroCostoDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.centroCosto.destroyAll.success'),
      );

      getHistory().push('/centro-costo');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: centroCostoDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default centroCostoDestroyActions;
